import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import classes from './mergeModalContent.module.scss';
import Button from '../../../_common/Form/Buttons/Button';
import { getPatientsRequest } from '../../../../store/actions/patients';
import Utils from '../../../../utils/utils';
import Api from '../../../../api/api';
import accountHelpers from '../../../../utils/accountHelpers';

const allowTypes = '.xlsx, .xlsm, .xls, .xlt, .csv';

const UploadIehpModalContent = ({ onCancel, filters }) => {
  const dispatch = useDispatch();

  const [uploadingFile, setUploadingFile] = useState(null);
  const [error, setError] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);

  const uploadFile = (e) => {
    Utils.onUploadFile(e, (file) => {
      setUploadingFile(file);

      setError(false);
    }, allowTypes);
  };

  const save = async () => {
    if (!uploadingFile) {
      setError(true);

      toast.error('Please upload file');
    } else {
      try {
        toast.success('IEHP upload started. It may take a few minutes');

        onCancel();

        await Api.importIehpActionTracker({
          userId: accountHelpers.getUser().id,
          file: uploadingFile,
        });

        toast.success('IEHP upload finished');
      } catch (e) {
        console.warn(e);

        toast.error(e.response?.data?.message || 'Wrong file data');
      }
    }
  };

  return (
    <div className={classes.wrapper}>
      <h2>Upload IEHP</h2>

      <div className={classes.upload_field_wrapper}>
        <label htmlFor="addIehpXLSX" className={`${classes.upload_field} ${error ? classes.error : ''}`}>
          <input
            type="file"
            id="addIehpXLSX"
            accept={allowTypes}
            onChange={uploadFile}
          />

          <p>
            {uploadingFile?.name || 'Add XLS or CSV file'}
          </p>
        </label>
      </div>

      <div className={classes.save_btns_wrapper}>
        <Button
          title="Cancel"
          type="button"
          clearButton
          onClick={onCancel}
        />

        <Button
          title="Upload"
          type="button"
          reverseColor
          onClick={save}
        />
      </div>
    </div>
  );
};

UploadIehpModalContent.propTypes = {
  onCancel: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired,
};

export default UploadIehpModalContent;
